
//import
import axios  from "axios";
 
 
//getToken
function getToken(){ //gettoken
  return localStorage.getItem('idToken')
}
 
//3 create
let httpClient = axios.create({
  baseURL:"https://i7iqi59x1k.execute-api.ap-northeast-1.amazonaws.com/dev",
  // baseURL:"https://owoo8a78sd.execute-api.ap-northeast-1.amazonaws.com/dev",
  timeout:6000,
  // withCredentials:true
})
 
//interceptors
httpClient.interceptors.request.use(
    //s
    config=>{
      if(getToken()){
        config.headers['Authorization']="Bearer " + getToken();
      }
      // console.log(config)
      //return
      return config
    },
    //err
    err=>{
      console.log(err);
      return Promise.reject(err)
    }
  )
  // interceptors
  httpClient.interceptors.response.use(
    //suss
    response=>{

      let res = response.data
      // console.log(res);
      
      if(res.code=='401'){
        window.location.href='/'
      }
      return Promise.resolve(res)
    },
    //errr
    err=>{

      console.log(err);
      console.log(err.status);
      if(err.status=='401'){
        localStorage.removeItem("idToken");
        localStorage.removeItem("userName");
        localStorage.removeItem("user");
        localStorage.removeItem("cognitoSubject");
        window.location.href='/'
      }
      return Promise.reject(err)
    }
  )
 
// get
export const GET = (url:any, config = {}) => httpClient.get(url, config);
 
// post
export const POST = (url:any, data = {}, config = {}) => httpClient.post(url, data, config);
 
// put
export const PUT = (url:any, data = {}, config = {}) => httpClient.put(url, data, config);
 
// delete
export const DEL = (url:any, config = {}) => httpClient.delete(url, config);


